import React from "react";
import { Form, Field, withFormik } from "formik";
import { compose, graphql } from "react-apollo";
import {
  webformFilterSchema,
  webformFilterForm,
} from "./webform-filter-schema";
import SelectField from "../../components/fields/select-field";
import CheckboxField from "../../components/fields/checkbox-field";
import DatePickerView from "../../components/fields/date-picker";
import CustomButton from "../../components/custom-button";
import { isNotNULL, sanitizeFilterObject } from "../../utils/helpers";
import { GET_ALL_WEBFORM_TYPES } from "../../graphql/queries";
import "./style.css";

const transformWebFormTypeObject = (webFormTypes) => {
  if (isNotNULL(webFormTypes.getAllWebFormTypes))
    return webFormTypes.getAllWebFormTypes.map((formType) => formType.name);
  return null;
};

/**
 * Webform filter form: type, responded/converted flags, and created/updated date ranges.
 */
const WebformFilterForm = ({ getAllWebFormTypes, ...props }) => {
  const { loading } = getAllWebFormTypes;
  const allFormTypes = transformWebFormTypeObject(getAllWebFormTypes);
  if (loading) {
    return allFormTypes;
  }
  return (
    <Form className="filter-menu">
      <div className="form-row">
        <div className="col-6 col-md-6">
          <Field
            label="Created From"
            name="created_at[0]"
            id="created_at[0]"
            maxDate={new Date()}
            component={DatePickerView}
          />
        </div>
        <div className="col-6 col-md-6">
          <Field
            label="Created To"
            name="created_at[1]"
            id="created_at[1]"
            maxDate={new Date()}
            component={DatePickerView}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="col-md-12">
          <Field
            id="unresponded"
            label="Unresponded"
            name="unresponded"
            component={CheckboxField}
          />
        </div>
        <div className="col-md-12">
          <Field
            id="unconverted"
            label="Unconverted"
            name="unconverted"
            component={CheckboxField}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="col-md-12">
          <Field
            name="type"
            label="Types"
            id="type"
            classStyle="filter-select-field"
            component={SelectField}
          >
            <option value="">All Types</option>
            {allFormTypes.map((type, index) => (
              <option key={index} value={index + 1}>
                {type}
              </option>
            ))}
          </Field>
        </div>
      </div>

      <div className="form-row">
        <CustomButton
          type="submit"
          btnValue="APPLY FILTERS"
          className="filter-apply-btn"
        />
      </div>
    </Form>
  );
};

const WebFormFilterFormWithFormik = withFormik({
  mapPropsToValues: (props) => {
    const { filter } = props;
    const allFormTypes = transformWebFormTypeObject(props.getAllWebFormTypes);
    const index = allFormTypes?.indexOf(filter?.form_type);
    return isNotNULL(filter)
      ? {
          type: index > -1 ? index + 1 : "",
          unresponded: filter.unresponded,
          unconverted: filter.unconverted,
          created_at: [
            filter.create_start_date || null,
            filter.create_end_date || null,
          ],
        }
      : webformFilterForm;
  },
  handleSubmit: (values, { props }) => {
    const allFormTypes = transformWebFormTypeObject(props.getAllWebFormTypes);
    props.setShow(false);
    props.setFilter(
      sanitizeFilterObject({
        form_type: values.type && allFormTypes[values.type - 1],
        unresponded: values.unresponded,
        unconverted: values.unconverted,
        create_start_date: values.created_at?.[0] || null,
        create_end_date: values.created_at?.[1] || null,
      })
    );
  },
  displayName: "webform-filter-form",
  enableReinitialize: true,
  validationSchema: webformFilterSchema,
})(WebformFilterForm);

export default compose(
  graphql(GET_ALL_WEBFORM_TYPES, {
    name: "getAllWebFormTypes",
  })
)(WebFormFilterFormWithFormik);
